import { scrollToTop } from "helpers/scroll-helpers";
import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SupportStickyBar from "components/support/SupportStickyBar";
import { resolveSelfCampaignPartnerExperience } from "../partnerFlow";
import SelfCampaignBrandHeader from "./SelfCampaignBrandHeader";
import "./SelfCampaignPageLayout.scss";

type SelfCampaignPageLayoutVariant = "create" | "design" | "activate";

type SelfCampaignPageLayoutProps = {
  children: ReactNode;
  footer?: ReactNode;
  rootClassName?: string;
  variant: SelfCampaignPageLayoutVariant;
  leadPartner?: string | null;
};

const SelfCampaignPageLayout: React.FC<SelfCampaignPageLayoutProps> = ({
  children,
  footer,
  leadPartner,
  rootClassName,
  variant,
}) => {
  const location = useLocation();
  const isPartnerFlow = Boolean(
    resolveSelfCampaignPartnerExperience({
      search: location.search,
      leadPartner,
    }),
  );
  const shouldShowSupportBar = !isPartnerFlow;

  useEffect(() => {
    scrollToTop();
  }, [location.pathname, location.search]);

  const rootClasses = ["self-campaign-page-layout", rootClassName]
    .filter(Boolean)
    .join(" ");

  const mainClasses = [
    "self-campaign-page-layout__main",
    `self-campaign-page-layout__main--${variant}`,
  ].join(" ");

  return (
    <div className={rootClasses}>
      {shouldShowSupportBar ? (
        <SupportStickyBar height={42} visibility="always" />
      ) : null}
      <SelfCampaignBrandHeader withTopOffset={shouldShowSupportBar} />
      <main className={mainClasses}>{children}</main>
      {footer}
    </div>
  );
};

export default SelfCampaignPageLayout;
